import React from "react";
import "../../css/MobileInfoSection.css";
import { useNavigate } from "react-router-dom";

// images (src/assets)
import circle1 from "../../../assets/mobile-app/circle-1.svg";
import circle2 from "../../../assets/mobile-app/circle-2.svg";
import circle3 from "../../../assets/mobile-app/circle-3.svg";

function MobileInfoSection() {
  const navigate = useNavigate();

  const cards = [
    {
      icon: circle1,
      title: "Instant Bug Reporting",
      desc: "If you just shake your phone and do nothing else, you have captured and reported the bugs easily and quickly. There is no need to stop what you are doing in order to log them because FrothTestops is very straightforward in allowing users to do it in real time.",
    },
    {
      icon: circle2,
      title: "Comprehensive Test Listings",
      desc: "One can very fast get hold of highly detailed listings of test scenarios, test cases, and also defects in which all these three are combined for easy and efficient test management.",
    },
    {
      icon: circle3,
      title: "Seamless Web and Mobile Sync",
      desc: "Every time you are filing a defect or attaching a document, it gets simultaneously updated on both the internet and the mobile versions of the application which means that you will have a uniform access to it no matter where you are.",
    },
  ];

  return (
    <section className="mobile-section">

      {/* HEADER */}
      <div className="mobile-header">
        <span className="breadcrumb">
          <span onClick={() => navigate("/")}>Home / </span>
          <span className="active">Mobile App</span>
        </span>

        <h1>Seamless Test Management — Wherever You Are</h1>

        <p>
          The mobile app of <span className="highlight">FrothTestops</span> is specifically created for agile teams that desire to remain flexible while not losing control. In a very simple manner you can manage test cases, check the progress, and report defects from any device—at any time, from any place. Being connected to your testing lifecycle is very easy through this mobile test management app as it provides you with total visibility and also real-time collaboration which is very convenient when you are on the go.
        </p>
      </div>

      {/* CARDS */}
      <div className="mobile-cards">
        {cards.map((card, idx) => (
          <div key={idx} className="mobile-card">

            <div className="card-header">
              <img src={card.icon} alt="icon" className="card-icon" />

              <h3>{card.title}</h3>
              <div className="underline" />
            </div>

            <p>{card.desc}</p>

          </div>
        ))}
      </div>

    </section>
  );
}

export default MobileInfoSection;